import { useState } from "react";
import type { FC } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

import { Lightbox } from "components/Lightbox";

import Capybara from "images/icons/oops.svg";

interface Props {
  incorrectCount: number;
  questionsCount: number;
  onModalClose?: () => void;
}

export const FirstIncorrectAnswerModal: FC<Props> = ({ incorrectCount, questionsCount, onModalClose }) => {
  const { t } = useTranslation("tutoring");
  const [isShown, setIsShown] = useState(true);

  const onClose = () => {
    setIsShown(false);
    onModalClose?.();
  };

  // AIDEV-NOTE: Dřív bez `Modal.Header` — `onHide` už dřív šlo na `Modal` (ESC/backdrop
  // zavíral), křížek tak jen zpřístupňuje existující cestu ven, nic nového neotvírá. [TD-344]
  return (
    <Lightbox
      show={isShown}
      onHide={onClose}
      bodyClassName="text-center"
      bodyTitleId="first-incorrect-answer-title"
      footer={
        <Button variant="azure" onClick={onClose} className="flex-grow-1">
          <div className="px-5 text-nowrap">{t("modal.first_incorrect.close")}</div>
        </Button>
      }
    >
      <Capybara />
      {questionsCount === 1 ? (
        // Velikost drží `.fs-16`, ať se sjednocením na `h2` (globálně 17 px) nezmění
        // vzhled — původní `h4` měl 16 px ($h4-font-size). [TD-344]
        <h2 id="first-incorrect-answer-title" className={"my-20px fs-16"}>
          {t("modal.first_incorrect.title")}
        </h2>
      ) : (
        <h2 id="first-incorrect-answer-title" className={"my-20px fs-16"}>
          {t(`modal.first_incorrect.title${questionsCount === 1 ? "" : `_${incorrectCount}`}`)}
        </h2>
      )}
      <p className="m-0">{t("modal.first_incorrect.description")}</p>
    </Lightbox>
  );
};
